// extracted by mini-css-extract-plugin
module.exports = {"list":"list__3aGRz","listItem":"listItem__29Mlh","clickable":"clickable__25CCV"};